import { Link } from '@reach/router';
import React from 'react';
import { ButtonFilled } from '../components/ui';

const Error404 = () => (
  <div className="absolute absolute--fill flex-auto flex flex-column justify-center items-center tc pa3">
    <h1 className="display f2 mt2 mb0">Whoops!</h1>
    <p className="f6 mt2 mb4 lh-copy">We couldn&rsquo;t find the page you&rsquo;re looking for.</p>

    <Link to="/login">
      <ButtonFilled>Login</ButtonFilled>
    </Link>
  </div>
);

export default Error404;
